import { IConfig } from "../tenants/shared/interfaces/interface-config";

export const config = require(`../tenants/${process.env.REACT_APP_CLIENT}/config`).default as IConfig;